// @ts-nocheck

export type RoomGetWithOwnerMemos = typeof RoomGetWithOwnerMemos[keyof typeof RoomGetWithOwnerMemos];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoomGetWithOwnerMemos = {
  true: 'true',
  false: 'false',
} as const;
